import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { alpha } from "@mui/material/styles";
import { createAppTheme } from "../theme";
import { syncThemeForUser } from "../store/slices/themeSlice";

const AppThemeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.theme.mode);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(syncThemeForUser(user));
  }, [dispatch, user?.id, user?.username, user?.email]);

  useEffect(() => {
    document.body.dataset.themeMode = mode;
  }, [mode]);

  const theme = useMemo(() => createAppTheme(mode), [mode]);
  const cronGlobalStyles = useMemo(() => {
    if (theme.palette.mode !== "dark") {
      return {};
    }

    return {
      ".cron_builder": {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderColor: theme.palette.divider,
      },
      ".cron_builder select, .cron_builder input, .cron_builder textarea": {
        backgroundColor: alpha(theme.palette.common.white, 0.06),
        color: theme.palette.text.primary,
        borderColor: theme.palette.divider,
      },
      ".cron_builder label, .cron_builder .cron-builder-label, .cron_builder span":
        {
          color: theme.palette.text.primary,
        },
      ".cron_builder .nav-tabs .nav-link": {
        color: theme.palette.text.secondary,
      },
      ".cron_builder .nav-tabs .nav-link.active": {
        backgroundColor: alpha(theme.palette.primary.main, 0.18),
        color: theme.palette.text.primary,
        borderColor: theme.palette.divider,
      },
      ".cron_builder_bordering, .cron_builder .well": {
        backgroundColor: alpha(theme.palette.common.white, 0.04),
        borderColor: theme.palette.divider,
        color: theme.palette.text.primary,
      },
    };
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={cronGlobalStyles} />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
